import React from 'react';
import { PropTypes as RPT } from 'prop-types';

import Term from './Term.react';

export default class Letter extends React.Component {
  static propTypes = {
    letter: RPT.string,
    terms: RPT.array,
    getFieldName: RPT.func,
  }

  render() {
    const { letter, terms, getFieldName } = this.props;
    return (
      <div className="letter-tab">
        <h4 className="heading">{letter}</h4>
        <div className="product-boxes">
          {terms.map(term => (
            <Term
              key={term.id}
              title={term.title}
              field={getFieldName(term.field)}
              url={term.url}
            />
          ))}
        </div>
      </div>
    );
  }
}
